
    // Do not edit this file, it is auto-generated at build time!
    // See ./src/lib/svgr/index-template.js to modify the generation of this file.

    import dynamic from 'next/dynamic';
    import IcAirportPlane from './ic-airport-plane';
import IcAller from './ic-aller';
import IcArrowBack from './ic-arrow-back';
import IcArrowForwardCircle from './ic-arrow-forward-circle';
import IcArrowUp from './ic-arrow-up';
import IcArrow from './ic-arrow';
import IcBurger from './ic-burger';
import IcCalendar from './ic-calendar';
import IcCall from './ic-call';
import IcCheck from './ic-check';
import IcChevronDownCircle from './ic-chevron-down-circle';
import IcChevronDown from './ic-chevron-down';
import IcChevronForward from './ic-chevron-forward';
import IcChevronUp from './ic-chevron-up';
import IcClose from './ic-close';
import IcDot from './ic-dot';
import IcFacebook from './ic-facebook';
import IcFilter from './ic-filter';
import IcHotel from './ic-hotel';
import IcInfoCircle from './ic-info-circle';
import IcInstagram from './ic-instagram';
import IcLevelIndicatorFill from './ic-level-indicator-fill';
import IcLevelIndicatorStroke from './ic-level-indicator-stroke';
import IcMediaContent from './ic-media-content';
import IcMinus from './ic-minus';
import IcPlane from './ic-plane';
import IcPlus from './ic-plus';
import IcProfile from './ic-profile';
import IcSailShip from './ic-sail-ship';
import IcSearch from './ic-search';
import IcSorter from './ic-sorter';
import IcStartFill from './ic-start-fill';
import IcStartStroke from './ic-start-stroke';
import IcTag from './ic-tag';
import IcTravelBus from './ic-travel-bus';
import IcTravelTrain from './ic-travel-train';
import IcYoutube from './ic-youtube';
    export const staticIcons = { IcAirportPlane,
IcAller,
IcArrowBack,
IcArrowForwardCircle,
IcArrowUp,
IcArrow,
IcBurger,
IcCalendar,
IcCall,
IcCheck,
IcChevronDownCircle,
IcChevronDown,
IcChevronForward,
IcChevronUp,
IcClose,
IcDot,
IcFacebook,
IcFilter,
IcHotel,
IcInfoCircle,
IcInstagram,
IcLevelIndicatorFill,
IcLevelIndicatorStroke,
IcMediaContent,
IcMinus,
IcPlane,
IcPlus,
IcProfile,
IcSailShip,
IcSearch,
IcSorter,
IcStartFill,
IcStartStroke,
IcTag,
IcTravelBus,
IcTravelTrain,
IcYoutube, }
    export const icons = { IcAirportPlane: dynamic(() => import('./ic-airport-plane')),
IcAller: dynamic(() => import('./ic-aller')),
IcArrowBack: dynamic(() => import('./ic-arrow-back')),
IcArrowForwardCircle: dynamic(() => import('./ic-arrow-forward-circle')),
IcArrowUp: dynamic(() => import('./ic-arrow-up')),
IcArrow: dynamic(() => import('./ic-arrow')),
IcBurger: dynamic(() => import('./ic-burger')),
IcCalendar: dynamic(() => import('./ic-calendar')),
IcCall: dynamic(() => import('./ic-call')),
IcCheck: dynamic(() => import('./ic-check')),
IcChevronDownCircle: dynamic(() => import('./ic-chevron-down-circle')),
IcChevronDown: dynamic(() => import('./ic-chevron-down')),
IcChevronForward: dynamic(() => import('./ic-chevron-forward')),
IcChevronUp: dynamic(() => import('./ic-chevron-up')),
IcClose: dynamic(() => import('./ic-close')),
IcDot: dynamic(() => import('./ic-dot')),
IcFacebook: dynamic(() => import('./ic-facebook')),
IcFilter: dynamic(() => import('./ic-filter')),
IcHotel: dynamic(() => import('./ic-hotel')),
IcInfoCircle: dynamic(() => import('./ic-info-circle')),
IcInstagram: dynamic(() => import('./ic-instagram')),
IcLevelIndicatorFill: dynamic(() => import('./ic-level-indicator-fill')),
IcLevelIndicatorStroke: dynamic(() => import('./ic-level-indicator-stroke')),
IcMediaContent: dynamic(() => import('./ic-media-content')),
IcMinus: dynamic(() => import('./ic-minus')),
IcPlane: dynamic(() => import('./ic-plane')),
IcPlus: dynamic(() => import('./ic-plus')),
IcProfile: dynamic(() => import('./ic-profile')),
IcSailShip: dynamic(() => import('./ic-sail-ship')),
IcSearch: dynamic(() => import('./ic-search')),
IcSorter: dynamic(() => import('./ic-sorter')),
IcStartFill: dynamic(() => import('./ic-start-fill')),
IcStartStroke: dynamic(() => import('./ic-start-stroke')),
IcTag: dynamic(() => import('./ic-tag')),
IcTravelBus: dynamic(() => import('./ic-travel-bus')),
IcTravelTrain: dynamic(() => import('./ic-travel-train')),
IcYoutube: dynamic(() => import('./ic-youtube')), } as const;
    export const iconNames = [ 'IcAirportPlane',
'IcAller',
'IcArrowBack',
'IcArrowForwardCircle',
'IcArrowUp',
'IcArrow',
'IcBurger',
'IcCalendar',
'IcCall',
'IcCheck',
'IcChevronDownCircle',
'IcChevronDown',
'IcChevronForward',
'IcChevronUp',
'IcClose',
'IcDot',
'IcFacebook',
'IcFilter',
'IcHotel',
'IcInfoCircle',
'IcInstagram',
'IcLevelIndicatorFill',
'IcLevelIndicatorStroke',
'IcMediaContent',
'IcMinus',
'IcPlane',
'IcPlus',
'IcProfile',
'IcSailShip',
'IcSearch',
'IcSorter',
'IcStartFill',
'IcStartStroke',
'IcTag',
'IcTravelBus',
'IcTravelTrain',
'IcYoutube', ] as const;
    